/* eslint-disable react-hooks/exhaustive-deps */
import { useForm } from "@mantine/form";
import useMaster from "hook/useMaster";
import { PAGINATION_ITEM_LIMIT } from "libs/data-access/constant";
import { useApi } from "libs/data-access/src/api/useApi";
import { useEffect, useState } from "react";
import { IAffiliateSignUpForm, IAffiliateList, TPaginationStatus } from "types";
import { checkPAN, showToast } from "utils/utility"
import { initialFormValues } from "initialStates";
import { usePagination } from "hook/usePagination";
import { useAffiliateData } from "libs/data-access";

import { NewAffiliateStep1Validation, NewAffiliateStep2Validation } from "./affiliateValidator";

const useAffiliates = () => {

  const {
    postData,
    putData,
    patchData
  } = useApi();
  const {
    getAffiliateData
  } = useAffiliateData();
  const {
    allCountryList,
    getAllCountryList,
    allStateList,
    getAllStateListByCountryId,
    allCompanyTypes,
    getAllCompanyTypes,
  } = useMaster();

  // const [isLoading, setIsLoading] = useState(false);
  const [isBtnLoading, setIsBtnLoading] = useState(false);
  const [isLoadingIndex, setIsLoadingIndex] = useState<number | undefined>(undefined);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formStep, setFormStep] = useState<number>(1);
  const [isAgreeWithTerm, setIsAgreeWithTerm] = useState<boolean>(false);
  const [formAction, setFormAction] = useState<"add" | "edit">("add");
  // const [affiliateList, setAffiliateList] = useState<IAffiliateList[]>([]);
  const [validations, setValidations] = useState({});
  const [PANVerification, setPANVerification] = useState<{
    PAN: string | null;
    isValid: boolean;
    isVerifying: boolean;
  }>({
    PAN: null,
    isValid: false,
    isVerifying: false
  });
  const [isUpdatingStatus, setIsUpdatingStatus] = useState<boolean>(false);
  const [debouncedValue, setDebouncedValue] = useState<string>("");
  // const [queryParams, setQueryParams] = useState<{
  //   searchIt: string | null
  // }>({
  //   searchIt: null
  // });
  const [paginationQueryParams, setPaginationQueryParams] = useState<{
    id: number | null;
    date: string | null;
  }>({
    id: null,
    date: null
  });
  const [sortingDetails, setSortingDetails] = useState<{
    sortBy: "id" | "createdDate";
    sortingOrder: "ASC" | "DESC";
  }>({
    sortBy: "createdDate",
    sortingOrder: "DESC"
  });


  useEffect(() => {
    if (formStep === 1) {
      setValidations(NewAffiliateStep1Validation)
    } else {
      setValidations({ ...NewAffiliateStep1Validation, ...NewAffiliateStep2Validation })
    };
  }, [formStep]);

  const affiliateForm = useForm({
    mode: "uncontrolled",
    initialValues: initialFormValues,
    validate: validations,
    transformValues: (values) => ({
      ...values,
      countryId: Number(values.countryId),
      stateId: Number(values.stateId),
      tdsExemptionRate: values.tdsExemptionRate ? +values.tdsExemptionRate : null,
      tdsExemptionCode: values.tdsExemptionCode ? +values.tdsExemptionCode : null,
      tdsExemptionNumber: values.tdsExemptionNumber ? +values.tdsExemptionNumber : null,
    })
  });

  useEffect(() => {
    // getAffiliateList("INITIAL_PAGE");
    getAllCountryList();
    getAllCompanyTypes()
  }, []);


  // HANDLER FUNCTION
  const handleClickEdit = (item: IAffiliateList) => {
    let FormValue: IAffiliateSignUpForm = {
      id: item.id,
      companyName: item.companyName,
      website: item.website,
      firstAddress: item.firstAddress,
      secondAddress: item.secondAddress,
      countryId: item.countryId?.toString(),
      stateId: item.stateId?.toString(),
      city: item.city,
      pinCode: item.pinCode,
      companyType: item.companyType,
      panNumber: item.panNumber,
      tdsExemptionNumber: item.tdsExemptionNumber,
      lookToBookRatioSearch: item.searchBookingRatio,
      lookToBookRatioBook: item.bookingRatio,
      tdsExemptionLimit: item.tdsExemptionLimit,
      tdsExemptionRate: +item.tdsExemptionRate,
      tdsExemptionCode: +item.tdsExemptionCode,
      xlCode: item.xlcode,
      isLogoAdvice: item.logoInvoice,
      isCorporate: item.corporate,
      isSupplierPromoCode: item.supplierPromoCode,
      gstNumber: item.gstNumber,
      email: item.emailId,
      mobileNumber: item.mobileNumber,
      aadhaarCardId: item.aadharCardMediaId,
      panCardId: item.panCardMediaId,
      gstId: item.gstMediaId,
      drivingLicenseId: item.drivingLicenseMediaId,
      companyLogoId: item.companyLogoMediaId,
      title: item.title,
      contactNumber: item.contactNumber,
      firstName: item.firstName,
      lastName: item.lastName,
      pmlAffiliate: item.affiliateStatus,
      aadhaarNumber: item.aadhaarNumber,
      companyRegistrationId: item.companyRegistrationId
    };

    affiliateForm.setValues(FormValue);
    getAllStateListByCountryId(+FormValue.countryId);
    setIsModalOpen(true);
    setFormAction("edit");
  };


  //  API FUNCTION
  const verifyPAN = async () => {

    // const formData = affiliateForm.getTransformedValues();
    // affiliateForm.setFieldValue("panNumber", PANVerification.PAN?.trim() as string);
    // affiliateForm.setFieldValue("FirstName", formData.firstName);
    // affiliateForm.setFieldValue("LastName", formData.lastName);

    // setPANVerification({
    //   PAN: PANVerification.PAN?.trim() as string,
    //   isValid: true,
    //   isVerifying: false
    // });

    // return;

    const formValues = affiliateForm.getTransformedValues();

    if (!PANVerification.PAN) {
      showToast({
        type: "warning",
        message: "Enter PAN number!"
      });
      return;
    };

    if (PANVerification.PAN.length !== 10) {
      showToast({
        type: "warning",
        message: "Enter valid PAN number!"
      });
      return;
    };

    if (!checkPAN(PANVerification.PAN)) {
      showToast({
        type: "warning",
        message: "Enter valid PAN number!"
      });
      return;
    };

    if (!formValues.firstName) {
      showToast({
        type: "warning",
        message: "Enter first name!"
      });
      return;
    };

    if (!formValues.lastName) {
      showToast({
        type: "warning",
        message: "Enter last name!"
      });
      return;
    };

    setPANVerification({ ...PANVerification, isVerifying: true });

    const payload = {
      panNumber: PANVerification.PAN?.trim(),
      nameOnCard: formValues.firstName + " " + formValues.lastName,
      dob: "06/03/1990"
    };

    const response = await postData("unsecure/pan-card/verification", payload);

    setPANVerification({ ...PANVerification, isVerifying: false });

    if (response.isSuccess) {
      // console.log("PAN validated successfully: ", response.data.data);
      const data: {
        panValid: boolean;
        nameValid: boolean;
        panNumber: string;
        panName: string;
        dob: string;
      } = response.data.data;

      if (data.panValid === false) {
        showToast({
          type: "error",
          time: 1000 * 8,
          title: "PAN is not valid",
          message: "Please provide PAN number as per PAN card"
        });
        return;
      };

      if (data.panNumber === payload.panNumber) {
        const firstName = data.panName.split(" ")[0];
        const lastName = data.panName.split(" ")[1] || "";

        affiliateForm.setFieldValue("panNumber", data.panNumber);
        affiliateForm.setFieldValue("FirstName", firstName);
        affiliateForm.setFieldValue("LastName", lastName);

        setPANVerification({
          PAN: data.panNumber,
          isValid: true,
          isVerifying: false
        });

        showToast({
          type: "success",
          message: "PAN validated successfully!"
        });
      } else {
        showToast({
          type: "error",
          message: "PAN number does not match!"
        });
      };
    } else {
      console.log("Error while validating PAN: ", response);
      showToast({
        type: "error",
        title: "Error while validating PAN",
        message: response.message || "Error while validating PAN"
      });
    };

  };


  const {
    dataList: affiliateList,
    setDataList,
    isLoading,
    setSearchText,
    searchText,
    goToNextPage,
    goToPreviousPage,
    disablePrev,
    disableNext,
    initialLoading,
    setTriggerNextPage,
    setTriggerPreviousPage,
    goToInitialPage
  } = usePagination<IAffiliateList>({
    fetchListData: getAffiliateData,
    maxLimit: 25,
    // sortby: sortingDetails?.sortBy,
    sortingOrder: sortingDetails?.sortingOrder,
    // extraQueryParams: queryParams as Record<string, string | number | boolean>,
    paginationParams: paginationQueryParams as Record<string, string | number | boolean>,
    dependencies: []
  });


  const postNewAffiliate = async () => {
    setIsBtnLoading(true);

    const formValues = affiliateForm.getTransformedValues();
    // console.log("Payload For Affiliate: ", formValues);

    const response = await postData(`affiliate/affiliate/signup`, formValues);

    if (response.isSuccess) {
      showToast({
        message: "Saved Successfully",
        type: "success",
      });
      goToInitialPage();
      setIsModalOpen(false);
      affiliateForm.reset();
      setFormStep(1);
    } else {
      showToast({
        message: response.message,
        type: "error",
      });
    };

    setIsBtnLoading(false);
  };

  const updatedAffiliate = async () => {
    const formValues = affiliateForm.getTransformedValues();
    const { id } = formValues;

    // Ensure companyRegistrationId is included in the payload
    const payload = {
      ...formValues,
      companyRegistrationId: formValues.companyRegistrationId || null
    };

    setIsBtnLoading(true);
    const response = await putData(`affiliate/update/${id}`, payload);
    if (response.isSuccess) {
      showToast({
        message: "Status Update Successfully",
        type: "success",
      });
      
      goToInitialPage();
      setIsModalOpen(false);
      setFormAction("add");
      affiliateForm.reset();
      setFormStep(1);
    }
    else {
      showToast({
        message: response.message,
        type: "error",
      });
    }
    setIsBtnLoading(false);
  };

  const updatedAffiliateStatus = async (affiliateId: number, status: "ACTIVE" | "INACTIVE" | "DELETED") => {
    setIsUpdatingStatus(true);

    const response = await patchData(`affiliate/change-status/${affiliateId}?status=${status}`);

    if (response.isSuccess) {
      // console.log("Status updated successfully: ", response.data.data);

      const STATUS = response.data.data;

      let affiliates = JSON.parse(JSON.stringify(affiliateList));

      for (let each of affiliates) {
        if (each.id === affiliateId) {
          each.status = STATUS;
        };
      };

      setDataList(affiliates);
    } else {
      console.log("Error while updating status: ", response);
      showToast({
        type: "error",
        message: response.message || "Error occurred while updating status!"
      });
    };

    setIsUpdatingStatus(false);
  };


  return {
    allCountryList,
    allCompanyTypes,
    allStateList,
    getAllStateListByCountryId,
    isModalOpen,
    setIsModalOpen,
    isAgreeWithTerm,
    setIsAgreeWithTerm,
    formAction,
    setFormAction,
    formStep,
    setFormStep,
    isLoadingIndex,
    isBtnLoading,
    affiliateForm,
    postNewAffiliate,
    updatedAffiliate,
    affiliateList,
    handleClickEdit,
    isUpdatingStatus,
    updatedAffiliateStatus,
    // getAffiliateList,
    getAllCountryList,
    getAllCompanyTypes,
    PANVerification,
    setPANVerification,
    verifyPAN,

    setSearchText,
    searchText,
    // queryParams,
    // setQueryParams,
    isLoading,
    disablePrev,
    disableNext,
    setTriggerNextPage,
    setTriggerPreviousPage,
    paginationQueryParams,
    setPaginationQueryParams,
  };
};

export default useAffiliates;
